import React, { useState, useEffect, useRef } from "react";
import Draggable from "react-draggable";
import "../../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAnglesDown,
  faAnglesRight,
  faClose,
  faCompress,
  faExpand,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import SensorTypeSelect from "./ExtremrHeavyRainfallSelect/SensorTypeSelect";
import ExtremeHeavyRainfallTable from "./ExtremeHeavyRainfallTable/ExtremeHeavyRainfallTable";
import { ResizableBox } from "react-resizable";

interface Props {
  isVisible: boolean;
  handleClosePopup: () => void; 
}

const ExtremeHeavyRainfall: React.FC<Props> = (props) => {
  const [showSensorSelect, setShowSensorSelect] = useState<boolean>(false);
  const [activeFullScreen, setActiveFullScreen] = useState<boolean>(false);
  const fullscreenModal = useRef<HTMLDivElement | null>(null);
  const [dimensions, setDimensions] = useState({
    resizableBoxwidth: 0,
    resizableBoxheight: 0,
  });

  //----------------resibleBox Function----------------

  const updateDimensions = () => {
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    setDimensions({
      resizableBoxwidth: vw * 0.65,
      resizableBoxheight: vh * 0.6,
    });
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const openContentFullscreen = () => {
    if (!document.fullscreenElement) {
      enterFullscreen();
    } else {
      exitFullScreen();
    }
  };

  const enterFullscreen = () => {
    const elem = fullscreenModal.current;
    if (elem) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
      setActiveFullScreen(true);
    }
  };

  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
    setActiveFullScreen(false);
  };



  const headerStyle: React.CSSProperties = {
    cursor: "move",
    marginBottom: "10px",
    display: "absolute",
  };

  const date = new Date().toLocaleDateString();
  const time = new Date().toLocaleTimeString();

  const hideDialog = () => {
  props.handleClosePopup(); 
  };

  const { isVisible } = props;


  const toggleSensorSelecteOverlay = () => {
    setShowSensorSelect((prevState) => !prevState);
  };

  const closeSensorSelectOverlay = () => {
    setShowSensorSelect(false);
  };

  return (
    <>
    {isVisible && ( <div
    >

        <Draggable handle=".drag-handle" enableUserSelectHack={false}>
        <ResizableBox
            className="custom-resizable-box"
            //width={988}
            //height={450}
            width={dimensions.resizableBoxwidth}
            height={dimensions.resizableBoxheight}
            minConstraints={[500, 300]}
            /* maxConstraints={[800, 600]} */ resizeHandles={[
              "se",
              "sw",
              "ne",
              "nw",
            ]}
            style={{ zIndex: 1, left: "17.5vw", top: "-15vh" }}
          >
          <div
            ref={fullscreenModal}
            style={{
                           //top: "-15vh",
                //left: "17.5vw",
                borderRadius: "3px",
                width: "100%", //"65vw",
                height: "100%", //"60vh,"
              position: "relative",
              display: "flex",
              flexDirection: "column",
              overflowY: "hidden",
              backgroundColor: "rgba(27, 18, 18, 0.9)",
            }}
          >
            <div style={headerStyle} className="drag-handle">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  padding: "3px 5px",
                  backgroundColor: "rgba(85, 84, 95, 0.4)",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                ></div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "rgba(255,255,255, 0.8)",
                  }}
                >
                  Sensor Reading
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  <FontAwesomeIcon
                    onClick={openContentFullscreen}
                    onTouchStart={openContentFullscreen}
                    style={{
                      borderRadius: "50%",
                      margin: "5px 10px",
                      width: "20px",
                      height: "20px",
                      color: "#dc143c",
                      cursor: "pointer",
                    }}
                    size="xl"
                    icon={activeFullScreen ? faCompress : faExpand}
                  />
                  <FontAwesomeIcon
                    onClick={hideDialog}
                    onTouchStart={hideDialog}
                    style={{
                      border: "3px solid #dc143c",
                      borderRadius: "50%",
                      margin: "5px 0px",
                      width: "20px",
                      height: "20px",
                      color: "#dc143c",
                      cursor: "pointer",
                    }}
                    size="xl"
                    icon={faClose}
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                margin: "10px 10px 0 10px",
                height: "100%",
                overflowY: "auto",
                padding: "0 5px",
              }}
            >
              {showSensorSelect && (
                <SensorTypeSelect onClose={closeSensorSelectOverlay} />
              )}
              <div
                style={{
                  display: "flex",
                  height: "10%",
                  width: "100%",
                  justifyContent: "flex-end",
                  padding: "0 0 10px 0",
                }}
              >
                <div
                  style={{
                    color: "white",
                  }}
                >
                  <button
                    onClick={toggleSensorSelecteOverlay}
                    onTouchStart={toggleSensorSelecteOverlay}
                    style={{
                      backgroundColor: "rgba(85, 84, 95, 0.4)",
                      outline: "none",
                      border: "0",
                      borderRadius: "2px",
                      width: "8rem",
                      height: "1.5rem",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    Sensor Type
                  </button>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "100%",
                }}
              >
                <ExtremeHeavyRainfallTable />
              </div>
            </div>
          </div>
          </ResizableBox>
        </Draggable>
  
    </div>
  )}
  </>
  );
};

export default ExtremeHeavyRainfall;
